var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import SchedulesForm from './containers/SchedulesForm';
import SchedulesTable from './containers/SchedulesTable';
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Index.prototype.render = function () {
        return (React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/schedules", component: SchedulesTable }),
            React.createElement(Route, { exact: true, path: "/schedules/create", component: SchedulesForm }),
            React.createElement(Route, { exact: true, path: "/schedules/:id", render: function (props) { return React.createElement(SchedulesForm, __assign({}, props)); } })));
    };
    return Index;
}(Component));
export default Index;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Schedules/index.tsx
// module id = 1545
// module chunks = 0